export default __webpack_public_path__ + "static/media/tour1.f5aac75e.webp";